import { useState } from "react";
import ButtonNavigatorComponent from "../../../../../components/ButtonNavigator";
import { TableComponent, TH, THeadTR } from "../../../../../components/Table v2";
import useTimeSheetStore from "../store/useStore";
import { RowFilterComponent } from "./RowFilterContainer";
import TBodyTimeSheet from "./TBodyTimeSheet";

export default function TableTimeSheet() {
  const { dateGridList, page, selectSize } = useTimeSheetStore();
  const { setPage, setSelectSize, renderHeaderTable } = useTimeSheetStore();

  return (
    <>
      <div className="bg-white rounded-t-xl">
        <div className="w-auto max-h-70vh flex flex-col rounded-t-xl overflow-y-auto">
          <RowFilterComponent />
          <TableComponent className="shadow-none">
            {dateGridList?.length ? (
              <>
                <THeadTR className="flex-row">
                  <TH>Data</TH>
                  {Array.from({ length: renderHeaderTable() }).map(() => {
                    return (
                      <>
                        <TH>Projeto</TH>
                        <TH className="text-center">Registro</TH>
                      </>
                    );
                  })}

                  <TH className="text-center">Total de Horas</TH>
                  <TH className="text-center">Editar Registro</TH>
                  <TH className="text-center">Apagar Registro</TH>
                </THeadTR>
                <tbody>
                  <TBodyTimeSheet listRender={dateGridList} />
                </tbody>
              </>
            ) : (
              <div className="justify-center mt-10">
                <h1 className="text-3xl text-textPrimary">Não há registros para a busca realizada.</h1>
              </div>
            )}
          </TableComponent>
        </div>
      </div>
      <ButtonNavigatorComponent page={page} setPage={setPage} selectSize={selectSize} setSelectSize={setSelectSize} list={dateGridList} />
    </>
  );
}
